"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alerts = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _icons = require("@material-ui/icons");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["itemColor"],
  _excluded2 = ["onClick", "children", "severity"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Mui 기본
// 아이콘
// 폰트 및 컬러 (커스텀)
////////////////////////////////////////////////////////////////////////////////////////
// 인터페이스
////////////////////////////////////////////////////////////////////////////////////////
// CSS 스타일
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    // 자동적용 - 기본 설정
    root: {
      // 패딩값 조정
      padding: 0,
      // 도형 크기 및 모양, 정렬
      borderRadius: function borderRadius(props) {
        return props.mode === "web" ? "4px" : 0;
      },
      alignItems: "center",
      // 배경(도형) 컬러
      backgroundColor: function backgroundColor(props) {
        switch (props.severity) {
          case "success":
            return _pittaModules.LightColors.secondary["16"];
          case "warning":
            return _pittaModules.LightColors.secondary["18"];
          case "error":
            return _pittaModules.LightColors.secondary["14"];
          default:
            return _pittaModules.LightColors.secondary["16"];
        }
      }
    },
    // 자동적용 - web, mobile 아이콘 간격 조절
    icon: {
      // 패딩값 조정
      padding: 0,
      // 마진값 조정
      margin: function margin(props) {
        return props.mode === "web" ? "6px 8px 7px" : "8px 8px 8px 12px";
      },
      // 아이콘 가운데로
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    // 설정적용 - 아이템(아이콘,텍스트) 컬러 설정
    itemColor: {
      color: function color(props) {
        switch (props.severity) {
          case "success":
            return _pittaModules.LightColors.secondary["15"];
          case "warning":
            return _pittaModules.LightColors.secondary["17"];
          case "error":
            return _pittaModules.LightColors.secondary["11"];
          default:
            return _pittaModules.LightColors.secondary["15"];
        }
      }
    },
    // 자동적용 - 텍스트 설정
    //@ts-ignore
    message: function message(props) {
      return _objectSpread({
        flexGrow: 1,
        paddingRight: theme.spacing(1)
      }, props.mode === "web" ? _Fonts.Fonts.Default.Small : _Fonts.Fonts.Default.Body);
    },
    // 설정적용 - mobile 액션 버튼설정
    action: {
      padding: 0,
      marginRight: 6,
      fontSize: "small"
    }
  });
});
////////////////////////////////////////////////////////////////////////////////////////
// 실제 컴포넌트
var Alerts = function Alerts(props) {
  var _useStyles = useStyles(props),
    itemColor = _useStyles.itemColor,
    classes = _objectWithoutProperties(_useStyles, _excluded);
  var onClick = props.onClick,
    children = props.children,
    severity = props.severity,
    restProps = _objectWithoutProperties(props, _excluded2);

  // 조건에 따라 아이콘 바꾸기
  var getIcon = function getIcon() {
    switch (severity) {
      case "success":
        return /*#__PURE__*/_react.default.createElement(_icons.CheckCircle, {
          fontSize: "default",
          className: itemColor
        });
      case "warning":
        return /*#__PURE__*/_react.default.createElement(_icons.Warning, {
          fontSize: "default",
          className: itemColor
        });
      case "error":
        return /*#__PURE__*/_react.default.createElement(_icons.Error, {
          fontSize: "default",
          className: itemColor
        });
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Alert.default, _extends({
    classes: classes,
    className: itemColor,
    severity: severity,
    icon: getIcon()
    // 모바일의 경우, 뒤에 아이콘 버튼 추가
    ,
    action: props.mode === "mobile" ? /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      className: "".concat(classes.action, " ").concat(itemColor),
      disableRipple: true,
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null)) : null
  }, restProps), children);
};
exports.Alerts = Alerts;